<!-- Shop-Item.vue -->

<template>
    <div class="product col-xxl-3 col-xl-4 col-md-6 col-12 mb-5">
        <div class="picture">
            <a :href="item.url">
                <img :src="item.img" class="img-fluid"/>
            </a>
        </div><!-- .picture -->
        <div class="informations">
            <table class="table table-bordered text-center m-0">
                <tbody>
                <tr>
                    <td>
                            <span class="text-uppercase fw-bolder">
                                {{ item.name }}
                            </span>

                        <span class="designation-additionnal d-block">
                            {{ item.designation_second }}&nbsp;
                        </span>
                    </td>
                </tr>
                </tbody>
            </table>

            <!-- info 1 -->
            <table class="table table-bordered text-center m-0">
                <tbody>
                <tr>
                    <td>
                        <span>Cond. <strong>{{ item.udv }}</strong></span>
                    </td>
                    <td>
                        <span>Réf. <strong>{{ item.id }}</strong></span>
                    </td>
                </tr>
                </tbody>
            </table>
            <!-- info -->

            <table class="table table-bordered text-center" v-if="(item.volume_alcool != '.00' && item.volume_alcool != ',00')">
                <tbody>
                <tr>
                    <td>{{ item.volume_alcool }}°</td>
                        <td v-if="(item.showPromo)" class="d-md-none">
                            <a :href="item.url" class="btn btn-sm btn-warning" style="border-radius:0px;"><i class="fas fa-star text-light"></i>
                           VOIR LA PROMO</a>
                        </td>

                </tr>
                </tbody>
            </table>

            <div class="cart" style="margin-bottom: 10px;">
                <div v-if="(item.promotion && item.promotion[0])" class="btn btn-sm btn-warning d-block">
                    <i class="fas fa-star text-light"></i>
                    {{ item.promotion[0].libelle2 }} = {{ item.promotion[0].libelle3 }}
                    <small>{{ item.promotion[0].date_fin }}</small>
                </div>

                <div v-if="(item.showPromo)" class="btn btn-sm btn-warning d-none d-md-block">
                    <i class="fas fa-star text-light"></i>
                    {{ item.libelle }}
                    {{ item.libelle2 }} = {{ item.libelle3 }}
                    <small>{{ item.date_fin }}</small>
                </div>
                <p v-if="item.qte" class="text-center pt-2 pb-3 m-0"><i class="fas fa-info-circle"></i> Dernière
                    quantité commandée : <b class="h5 fw-bold d-inline-block"></b></p>
            </div>

            <div v-if="favori" class="info-qte-cmd mb-2" style="font-size: 14px;">
                <div class="d-flex align-items-center">

                    <div class="me-2 d-none d-md-block">
                        <i class="fas fa-info-circle"></i>
                    </div>

                <table class="table table-bordered m-0">
                        <tbody>
                            <tr>
                                <td class="text-uppercase px-2 py-1">Quantité habituellement commandée</td>
                                <td class="fw-bold px-2 py-1 text-center">{{ item.favorite_quantite }}</td>
                            </tr>
                            <tr>
                                <td class="text-uppercase px-2 py-1">Dernière quantité commandée</td>
                                <td class="fw-bold px-2 py-1 text-center">{{ item.qte }}</td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>

            <div v-if="!guest" class="quantity">
                <div class="d-flex">
                    <div class="container-quantity">
                        <span class="minus" v-on:click="sub()">-</span>
                        <input id="quantity" v-model.number="product.quantite" :data-article-id="product.id" class="form-control"
                               min="0" name="quantity" step="1" type="number">
                        <span class="more" v-on:click="add()">+</span>
                    </div>
                    <button class="btn btn-success add-to-cart" @click.prevent="updateCart" :disabled="existsInCart"><i
                        class="fas fa-shopping-cart"></i></button>
                    <button class="btn btn-danger" type="reset" @click.prevent="removeFromCart"><i class="fas fa-trash-alt"></i></button>
                </div>
            </div>


        </div>
    </div>
</template>
<script>
import {mapActions} from 'vuex'

export default {
    name: 'Shop-Item',
    props: {
        item: Object,
        guest: String,
        favori: Boolean
    },
    data() {
        return {
            product: null,
            existsInCart:false,
            currentTimeout: null
        }
    },
    created() {
        this.checkIfExist()
    },
    computed: {

    },
    methods: {
        ...mapActions("cart", {
            addItem: "add",
            removeItem: "delete",
        }),

        checkIfExist(){
            if(this.item && this.$store.state.cart.products.hasOwnProperty(this.item.id)){
                this.product = this.$store.state.cart.products[this.item.id]
                this.existsInCart = true
            } else {
                this.existsInCart = false
                this.product = {
                    article_id: this.item.id,
                    quantite: (this.item.qte) ? this.item.qte : 0,
                    source_type: 'catalogue'
                }
            }
        },

        add() {
            this.product.quantite++
            this.updateCart()
        },
        sub() {
            if (this.product.quantite > 0) {
                this.product.quantite--
                this.updateCart()
            }
        },

        updateCart() {
            if (this.product.quantite >= 0) {
                if(this.currentTimeout){
                    clearTimeout(this.currentTimeout)
                }

                this.currentTimeout = setTimeout(this.doUpdateCart, 300)
            }
        },
        doUpdateCart(){
            //TODO: show loader
            this.addItem(this.product).then(() => {
                this.checkIfExist()
                /*this.$store.dispatch('toast', {
                    type: 'success',
                    title: 'Votre panier a bien été mis à jour.',
                    message: ''
                });*/
            }).catch((error) => {
                console.log(error);
                this.$store.dispatch('dispatchError', error);
            }).finally(() => {
                //TODO: hide loader
            })
        },
        removeFromCart(){
            this.removeItem(this.product).then(() => {
                this.checkIfExist()
               /*this.$store.dispatch('toast', {
                    type: 'success',
                    title: 'Votre panier a bien été mis à jour.',
                    message: ''
                });*/
            }).catch((error) => {
                this.$store.dispatch('dispatchError', error);
            }).finally(() => {
                //TODO: hide loader
            })
        }
    }
}
</script>
<style>
</style>
